import React from 'react';
import './reports.scss';

import Form from 'devextreme-react/form';
import Button from 'devextreme-react/button';

import {handleAuthError, useCheckUserAuthentication} from '../../globals';

import TreeView from 'devextreme-react/tree-view';
import { createStore } from 'devextreme-aspnet-data';
import { useState, useEffect, useMemo } from "react";

import CustomStore from "devextreme/data/custom_store";

export default function Reports(){

  const user = useCheckUserAuthentication();

  const [selectedReport, setSelectedReport] = useState(null);
  const [definition, setDefinition] = useState(null);
  const [formData, setFormData] = useState({});


  const reportsStore = useMemo(() => {

    return createStore({

      key:"id",
      loadUrl: process.env.REACT_APP_WEBAPP_DOMAIN + "/api/Report/GetFilteredReports",

      onBeforeSend(method, ajaxOptions){

        ajaxOptions.headers = {Authorization:`Bearer ${user.token}`};

      },

      errorHandler: (error) => {
        handleAuthError(error);
      }

    });

  }, [user.token]);
 

  function onSelect(e) {

    const report = e.itemData;

    // Categoria
    if (report.categoryId === null) {

        setSelectedReport(null);
        setDefinition(null);
        setFormData({});

        return;
    }

    // Report
    setSelectedReport(report);

    if (report.definitionJson) {

        const def = JSON.parse(report.definitionJson);

        setDefinition(def);

        const values = {};

        def.parameters.forEach(p => {
            values[p.name] = p.defaultValue ?? null;
        });

        setFormData(values);
    }
}

  function createEditor(field){

    const item = {

        dataField: field.name,
        label: {
          text: field.label
        }

    };

    switch(field.type){

        case "date":

          item.editorType="dxDateBox";
          break;

        case "text":

          item.editorType="dxTextBox";
          break;

        case "boolean":

          item.editorType="dxCheckBox";
          break;

        case "lookup":

          item.editorType="dxSelectBox";

          item.editorOptions = {

            dataSource: new CustomStore({
              key: "id",
              load: () => getLookup(field.lookup)
            }),

            valueExpr:"id",
            displayExpr: field.displayExpr,
            searchEnabled: true,
            showClearButton: true,
            placeholder: "Seleziona..."
          };

          break;

        default:

          item.editorType="dxTextBox";
    }

    return item;

  }

  async function executeReport(){

    const response = await fetch(

        process.env.REACT_APP_WEBAPP_DOMAIN + "/api/Reports/"+ selectedReport.code,

        {
          method:"POST",
          headers:{
              Authorization:`Bearer ${user.token}`,
              "Content-Type":"application/json"
          },

          body:JSON.stringify(formData)

        }

    );

    if (!response.ok) {
        const error = await response.text();
        console.error(error);
        alert(error);
        return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href=url;
    a.download=selectedReport.code+".xlsx";

    a.click();

  }

  const lookupCache = {};

  async function getLookup(code) {

    if (lookupCache[code]) {
        return lookupCache[code];
    }

    const response = await fetch(
      `${process.env.REACT_APP_WEBAPP_DOMAIN}/api/${code}`,
      {
        headers: {
            Authorization: `Bearer ${user.token}`
        }
      }
    );

    const data = await response.json();
    lookupCache[code] = data;
    return data;
  }
    
    
  return(
  <React.Fragment>
    <h2 className={'content-block'}>Reports</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        <div style={{ display:"flex", gap:20 }}>
          <div style={{width:500}}>
            <TreeView

              className="reports-tree"
              id="reports-treeview"
              dataStructure="plain"
              dataSource={reportsStore}
              keyExpr="id"
              displayExpr="description"
              parentIdExpr="categoryId"
              onItemClick={onSelect}
              selectionMode="single"
              selectByClick={true}
              focusStateEnabled={true}

            />
          </div>

          <div style={{flex:1}}>

            <div className="report-form">

              {definition ? (

                <>
                  <h3>{definition.title}</h3>

                  <Form
                      formData={formData}
                      colCount={2}
                      items={definition.parameters.map(createEditor)}
                      onFieldDataChanged={(e) =>
                          setFormData(e.component.option("formData"))
                      }
                  />

                  <div className="report-toolbar">

                    <Button
                        text="Scarica Excel"
                        type="success"
                        width={160}
                        stylingMode="contained"
                        onClick={executeReport}
                        icon="exportxlsx"
                    />

                  </div>
                </>

              ) : (

                <div className="report-placeholder">
                  <h3>Reports</h3>
                  <p>Seleziona un report dall'elenco per visualizzare i parametri.</p>
                </div>

              )}

            </div>

          </div>

        </div>
      </div>
    </div>
    
  </React.Fragment>
  )
};

